import React from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const { freeze, values } = Object;

const FormContainer = styled.div`
  border-bottom: 1px solid rgba(129, 199, 132, 1);
  margin-bottom: 8px;
`;

const Input = styled.input`
  max-width: 56px;
`;

const FormRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`;

const FormCell = styled.div`
  padding: 4px;
`;

const InputItem = ({ formVals, handleChange, options }) => (
  <FormCell>
    <Input
      name={options.name}
      id={options.id}
      type={options.type}
      min="0000-01-01"
      max="4600-12-31"
      value={formVals[options.name]}
      onChange={handleChange}
      placeholder={options.placeholder}
    />
  </FormCell>
);

const Select = styled.select`
`;

const id = new Date().getTime();

const SelectItem = ({ formVals, handleChange, options }) => {
  return (
    <FormCell>
      <Select
        value={formVals[options.name]}
        name={options.name}
        id={options.id}
        onChange={handleChange}
      >
        {options.options.map((option, i) => (
          <option key={`option-${id}-${i}`} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </FormCell>
  );
};

const formItems = freeze({
  interval: {
    id: "interval",
    name: "interval",
    type: "select",
    placeholder: "interval",
    options: ["days", "years"],
  },
  operator: {
    id: "operator",
    name: "operator",
    type: "select",
    options: ["add", "subtract"],
  },
  cycles: {
    name: "cycles",
    id: "cycles",
    type: "number",
    placeholder: "cycles",
  },
});

const EntryForm = ({ formVals, handleChange }) => (
  <FormContainer>
    <FormRow>
      <FormCell>
        <DatePicker
          style={{ width: 72 }}
          name="date"
          onChange={date =>
            handleChange({ target: { name: "date", value: date } })
          }
          selected={formVals["date"]}
        />
      </FormCell>
      {values(formItems).map((value, i) =>
        ["text", "number"].includes(value.type) ? (
          <InputItem
            formVals={formVals}
            key={`input-${i}`}
            options={value}
            handleChange={handleChange}
          />
        ) : (
          <SelectItem
            formVals={formVals}
            key={`select-${i}`}
            options={value}
            handleChange={handleChange}
          />
        )
      )}
    </FormRow>
  </FormContainer>
);

export default EntryForm;
